var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rcc-table"},[_vm._v(" TABLE ")])}
var staticRenderFns = []

export { render, staticRenderFns }